<template>
    <div class="btn-group">
        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
            Default Period - {{ preference }}
        </button>
        <div class="dropdown-menu">
            <a class="dropdown-item" @click="setDefaultPeriod(option)" v-for="option in options"
               href="#">{{ option.label }}</a>
        </div>
    </div>

</template>

<script>

export default {
    name: "DefaultPeriod",

    data() {
        return {
            options: [
                {value: '1 week', label: '1 Week'},
                {value: '2 weeks', label: '2 Weeks'},
                {value: '3 weeks', label: '3 Weeks'},
                {value: 'month', label: 'Month'},
            ],
            preference: '1 week',
        }

    },
    mounted() {

        this.getDefaultPeriod()
    },
    methods: {
        async setDefaultPeriod(period) {
            await axios.post('/users/preference', {
                "key": 'schedule_default_period',
                "value": period.value
            }).then(function (response) {
                window.location.reload()
            })
            //await this.getDefaultPeriod()
        },
        async getDefaultPeriod() {
            let result = await axios.get('/users/preference?key=schedule_default_period')
            this.preference = result.data || '2 week';
            this.$root.$refs.calendar.setDefaultPeriod(this.preference);

        }
    }
}
</script>

<style scoped>


</style>
